
import React from "react";
// import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
import { ScrollToTopOnLoad as LoadFresh } from "../../utils";
// import * as Config from "../../config";
/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
import {
  Box,
  useMediaQuery,
} from "@mui/material";
import { Helmet } from 'react-helmet';
import NavbarPublic from "../navbarPublic";
import Footer from "../footer";
/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
import DreamWidget from "../widgets/DreamWidget";
/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */


const DreamPage = () => {
  const isNonMobileScreens = useMediaQuery("(min-width:1000px)");


  return (
    <div>
      <Helmet>
        <title>SmartMetal Dream-o-matic - AI Video Generation Game, Artist Tool</title>
        <meta name="description" content="SmartMetal Dream-o-matic - AI Video Generation Game, Artist Tool" />
      </Helmet>
      <Box>
        <NavbarPublic/>
        <Box
          width="100%"
          // width={isNonMobileScreens ? "50%" : "93%"}
          padding="2rem 4% 2rem"
          display={isNonMobileScreens ? "flex" : "block"}
          gap="1.5rem"
          justifyContent="center"
        >
          <DreamWidget />
        </Box>


        <Box
          display="block"
          width="100%"
          gap="1.5rem"
          padding="0.0rem"
        >
          <Footer />
        </Box>
      </Box>
      <LoadFresh />
    </div>
  );
};

export default DreamPage;

